var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"view-stars",style:({
		opacity: 1 - _vm.$store.state.starfieldScrollRatio / _vm.maxStarRatio,
	})},[_c('canvas',{ref:"starCanvas"})])
}
var staticRenderFns = []

export { render, staticRenderFns }